// extracted by mini-css-extract-plugin
export default {"actionFooter":"BulkUpdateSyncConfirmButton_actionFooter__2nTG1"};